




































































































































































import Vue from 'vue'
import { AREA_TYPE_MAP } from '@/services/report/areaTypes'
import { getNestedValue } from '@/util/helpers'

export default Vue.extend({
  computed: {
    areaType(): string {
      return this.$store.getters['valuationEdit/areaType']
    },
    areaTypes() {
      return AREA_TYPE_MAP
    },
    layout(): number {
      return this.$store.getters['valuationEdit/layout']
    },
    configurationCode(): string {
      return this.$store.getters['valuationEdit/configurationCode']
    },
    isExtended(): boolean {
      return getNestedValue(
        this.$store.getters['valuationEdit/data'],
        ['apartmentLayoutExtension'],
        false
      )
    },
    months(): number {
      return this.$store.getters['valuationEdit/monthsPeriod']
    },
  },
})
